export default {
  /* Events */
  restaurant: 'Restaurante',
  bar: 'Barra',
  hotel: 'Hotel',
  museum: 'Museu',
  cultureHouse: 'Casa de Cultura',
  park: 'Parque',
  gym: 'Academia',
  comercialCenter: 'Centro de compras',
  theatre: 'Teatro',
  cafe: 'Cafeteria',
  library: 'Biblioteca',
  house: 'Casa',
  assistantsExportedSuccessfully: 'Assistentes exportados com sucesso',
  createEvent: 'Criar evento',
  mustChargeBeforeCreateEvents: 'Você deve cobrar dinheiro antes de criar eventos',
  events: 'Eventos',
  published: 'Publicado',
  notPublished: 'Não publicado',
  soldOut: 'Esgotado',
  publishEventToBeShownInSalesLists: 'Publique este evento a ser mostrado em listas de vendas',
  loadingEvents: 'Eventos de carregamento',
  noEventsRegistered: 'Nenhum evento registrado',
  publish: 'Publicar',
  soldTickets: 'Ingressos vendidos',
  availableTickets: 'Ingressos disponíveis',
  totalTickets: 'Valor dos ingressos',
  eventStateUpdated: 'Estado do evento atualizado',
  profileImage: 'Imagem de perfil',
  thePicture: 'A foto',
  thePictures: 'As fotos',
  theBanner: 'A faixa',
  eventRating: 'Avaliação do evento',
  priceRating: 'Avaliação de preço',
  profitability: 'Lucratividade',
  businessFee: 'Taxa de negócios',
  gatewayFee: 'Taxa de entrada',
  totalProfit: 'Resultado líquido',
  tags: 'Tags',
  createTag: 'Criar tag',
  purchase: 'Compra',
  /* End Events */
  createPromotor: 'Criar promotor',
  mustChargeBeforeCreatingPromotors: 'Você deve cobrar dinheiro antes de criar promotores',
  promotors: 'Promotores',
  showUrlToPromotor: 'Mostrar url para promotor',
  editPromotor: 'Editar promotor',
  setProfilePicture: 'Definir imagem de perfil',
  setBanner: 'Definir banner',
  deletePromotor: 'Excluir promotor',
  loadingPromotor: 'Carregando promotores',
  noPromotorsRegistered: 'Não há promotores registrados',
  createProductsCategory: 'Criar categoria de produtos',
  mustChargeBeforeCreatingProductsCategories: 'Você deve cobrar dinheiro antes de criar categorias de produtos',
  successfullyCreatedProductCategory: 'Produto criado com sucesso',
  successfullyUpdatedProductCategory: 'Produto atualizado com sucesso',
  productsCategories: 'Categorias de produtos',
  newProductsCategory: 'Novo Produto',
  editProductsCategory: 'Editar categoria de produtos',
  photos: 'Fotos',
  setProductsCategoryPhoto: 'Definir foto do categoria de produtos',
  deleteProductsCategory: 'Excluir o categoria de produtos',
  loadingProductsCategory: 'Categorias de produtos de carregamento',
  noProductsCategoriesRegistered: 'Não há categorias de produtos registrados',
  doYouWantToDeleteProductsCategory: 'Deseja excluir o categoria de produtos?',
  price: 'Preço',
  discountPrice: 'Preço de desconto',
  stock: 'Estoque',
  createProduct: 'Criar produto',
  mustChargeBeforeCreatingProducts: 'Você deve cobrar dinheiro antes de criar produtos',
  products: 'Produtos',
  newProduct: 'Novo Produto',
  editProduct: 'Editar produto',
  // // photos: 'Fotos',
  setProductPhoto: 'Definir foto do produto',
  deleteProduct: 'Excluir o produto',
  loadingProduct: 'Produtos de carregamento',
  noProductsRegistered: 'Não há produtos registrados',
  doYouWantToDeleteProduct: 'Deseja excluir o produto?',
  provider: 'Provedor',
  providers: 'Provedores',
  createProvider: 'Criar provedor',
  mustChargeBeforeCreatingProviders: 'Você deve cobrar dinheiro antes de criar provedores',
  newProvider: 'Novo Provedor',
  editProvider: 'Editar provedor',
  deleteProvider: 'Excluir provedor',
  loadingProvider: 'Fornecedores de carregamento',
  noProvidersRegistered: 'Não há provedores registrados',
  doYouWantToDeleteProvider: 'Deseja excluir o provedor?',
  providerHasBeenDeleted: 'O provedor foi excluído com sucesso',
  fabric: 'Tecido',
  fibre: 'Fibra',
  key: 'Chave',
  positionArc: 'Arco de Posição',
  acab: 'Acab',
  acabado: 'Acabado',
  refChina: 'Referência China',
  refClient: 'Cliente de referência',
  label: 'Rótulo',
  wide: 'Larga',
  weight: 'Peso',
  composition: 'Composição',
  perfomance: 'Perfomance',
  unitMeasure: 'Medida unitária',
  cantMtsFinals: 'cant Mts Finals',
  cantKlsFinals: 'cant Kls Finais',
  cantMtKl: 'cant Mt Kl',
  capMaxKl: 'tampa Max Kl',
  portOcupation: 'ocupação portuária',
  // newProduct: 'Nuevo producto',
  // editProduct: 'Editar producto',
  // deleteProduct: 'Eliminar producto',
  // loadingProduct: 'Cargando productos',
  // noProductsRegistered: 'No hay productos registrados',
  // doYouWantToDeleteProduct: '¿Desea borrar el producto?'
  productHasBeenDeleted: 'O produto foi excluído com sucesso',
  attachEventsInYourWebSite: 'Insira eventos em seu site',
  createDivElementToAttachEventsInYourWebSite: 'Para anexar eventos ao seu site você deve criar um elemento div com o id',
  andOtherWithTheId: 'e outro com o id',
  inYourSiteBody: 'Na etiqueta corporal do seu site',
  andThenAddTheNextScriptInTheFooter: 'E em seguida adicionar o próximo script ao rodapé do seu site',
  scriptCopied: 'Script copiado',
  errorCopyingTheScript: 'Erro copiando o script',
  exportAssistants: 'Assistentes de exportação',
  assistantsList: 'Lista de assistentes',
  assistantId: 'Id do assistente',
  loadingAssistants: 'Assistentes de carregamento',
  noAssistantsRegistered: 'Não há assistentes registrados.',
  registerDate: 'Data de inscrição',
  automatic: 'Automático',
  manual: 'Manual',
  creationType: 'Tipo de criação',
  errorLoadingEvent: 'Houve um erro carregando o evento',
  eventNotPublishedAndOutOfLists: 'Seu evento não foi publicado e não vai ser visto nas listas até que seja',
  eventDate: 'Data do evento',
  publishEvent: 'Publicar evento',
  seePromotorInYourWebSite: 'Veja o promotor em seu site',
  mustDoToSeePromotorInWebSite: 'Para ver o promotor você deve ter certeza de ter o widget de eventos anexado em seu site para inserir a próxima url',
  copy: 'Cópia',
  mustContactSupportToSeePromotorInWebSite: 'Para ver o promotor você deve entrar em contato com o suporte para obter uma url',
  errorCopyingUrl: 'Erro copiando a url',
  urlCopied: 'URL copiado',
  eventContacts: 'Contatos de eventos',
  doYouWantToDeletePromotor: 'Quer excluir o Dj?',
  /* Djs */
  view: 'Visão',
  djSuccessfullyCreated: 'Dj criado com sucesso',
  djSuccessfullyUpdated: 'Dj atualizado com sucesso',
  createDj: 'Criar dj',
  mustChargeBeforeCreatingDjs: 'Você deve recarregar o dinheiro antes de criar djs',
  djs: 'Djs',
  followers: 'Seguidores',
  showUrlToDj: 'Mostrar url para dj',
  editDj: 'Editar dj',
  deleteDj: 'Exluir dj',
  loadingDj: 'Carregando djs',
  noDjsRegistered: 'Não há djs registrados',
  doYouWantToDeleteDj: 'Deseja excluir o Dj?',
  seeDjInYourWebSite: 'Veja dj em seu site',
  mustDoToSeeDjInWebSite: 'Para ver o DJ, você deve ter o widget de eventos anexado ao seu site para inserir o próximo URL',
  mustContactSupportToSeeDjInWebSite: 'Para ver o dj, você deve entrar em contato com o suporte para obter um URL',
  /* End Djs */
  importAssistants: 'Assistentes de importação',
  event: 'Evento',
  assistantsImportedSuccessfully: 'Assistentes importados com sucesso',
  format: 'Formato',
  editEvent: 'Editar evento',
  newEvent: 'Novo evento',
  shortDescription: 'Descrição curta',
  note: 'Nota',
  insertNoteToSendInConfirmationEmail: 'Insira uma nota para enviar no e-mail de confirmação',
  isAnOnlineEvent: 'É um evento online',
  eventUrl: 'Url do evento',
  category: 'Categoria',
  startDate: 'Data de início',
  finishDate: 'Data de término',
  startDateAccess: 'Data de início',
  finishDateAccess: 'Data de término',

  /* Places */
  place: 'Lugar',
  places: 'Lugares',
  placeLocation: 'Localização do site',
  cantFindPlace: 'Não consegue encontrar um lugar? Registre um.',
  canFindPlace: 'Tem um lugar em mente? Selecione um.',
  mustChargeBeforeCreatingPlaces: 'Você deve cobrar dinheiro antes de criar um local',
  newPlace: 'Criar local',
  editPlace: 'Editar local',
  viewPlace: 'Ver local',
  setPlacePhoto: 'Carregar foto do local',
  deletePlace: 'Excluir local',
  loadingPlace: 'Carregando locais',
  noPlacesRegistered: 'Nenhum local registrado',
  doYouWantToDeletePlace: 'Deseja excluir este local?',
  infoPlace: 'Informação do Site',
  placeSocialNetworks: 'Redes sociais do site',
  placeContacts: 'Contatos do site',
  ExpAndOffs: 'Experiências e ofertas',
  experiences: 'Experiências',
  trips: 'Viagens',
  concerts: 'Concertos',
  offerings: 'Ofertas',
  veggie: 'Vegetariano',
  allergies: 'Alergias',

  latitude: 'Latitude',
  longitude: 'Longitude',
  organizer: 'Organizador',
  limitRegisterByIdentificationDocument: 'Registro limite por documento de identificação',
  cover: 'Cobrir',
  pictures: 'Fotos | Foto',
  eventCreated: 'Evento criado',
  promoter: 'Promotor',
  locationUrl: 'URL para localização',
  facebookMessageSendingUrl: 'Mensagem do Facebook enviando Url',
  facebookSiteUrl: 'Facebook Site Url',
  completeRequiredFields: 'Complete os campos necessários',
  promoterSuccessfullyCreated: 'Promotor foi criado com sucesso',
  promoterSuccessfullyUpdated: 'Promotor foi atualizado com sucesso',
  eventSocialNetworks: 'Redes sociais de eventos',
  socialNetworkSelect: 'Selecione a rede social',
  doYouWantDuplicate: 'Deseja duplicar este local?',
  isPlaceActive: 'Este local está ativo?',
  isThisPlaceRestaurant: 'Este lugar é um restaurante',
  configPlace: 'Configurações de local',
  placeRating: 'Classificação de lugar',
  placeTags: 'Tags do seu lugar',
  tagsHint: 'Digite uma tag e pressione Enter',
  pleaseTypeLocation: 'Digite seu endereço',
  diningStyle: 'Estilo de Jantar',
  dressCode: 'Código de roupa',
  acceptedPaymentMethods: 'Métodos de pagamento aceitos',
  parkingType: 'Tipo de estacionamento',
  casual: 'Casual',
  businessCasual: 'Business casual',
  casualElegant: 'Casual elegant',
  formal: 'Formal',
  jacketRequired: 'Jacket required',
  jacketAndTie: 'Jacket and tie',
  priceAverage: 'Preço médio',
  brunch: 'Escovar',
  lunch: 'Almoço',
  happyHour: 'Hora feliz',
  dinner: 'Jantar',
  daily: 'Diariamente',

  eventTypeCamping: 'Acampar, viajar ou recuar',
  eventTypeAttraction: 'Atração',
  eventTypeRace: 'Corrida ou evento de resistência',
  eventTypeDinner: 'Jantar ou gala',
  eventTypeWorkshop: 'Aula, curso ou oficina',
  eventTypeSignature: 'Aparência ou assinatura',
  eventTypeConcert: 'Concerto ou performance',
  eventTypeConference: 'Conferência',
  eventTypeConvention: 'Convenção',
  eventTypeMeetup: 'Evento ou reunião de rede',
  eventTypeFair: 'Feira, feira do consumidor ou exposição',
  eventTypeFestival: 'Festival ou feira',
  eventTypeParty: 'Festa ou reunião social',
  eventTypeCompetition: 'Jogo ou competição',
  eventTypeOther: 'De outros',
  eventTypeProjection: 'Projeção',
  eventTypeRally: 'Comício',
  eventTypeSeminar: 'Seminário ou palestra',
  eventTypeTournament: 'Torneio',
  eventTypeVisit: 'Visita',

  eventCategoryAcademic: 'Atividades escolares',
  eventCategoryHobbies: 'Hobbies e interesses especiais',
  eventCategoryArts: 'Artes cênicas e visuais',
  eventCategoryScience: 'Ciência e Tecnologia',
  eventCategoryCinema: 'Cinema, mídia e entretenimento',
  eventCategoryCars: 'Carros, navios e aviões',
  eventCategoryCommunities: 'Comunidade e cultura',
  eventCategorySports: 'Esportes e saúde',
  eventCategoryHolidays: 'Dias de festa',
  eventCategoryFamily: 'Família e educação',
  eventCategoryGastronomy: 'Gastronomia',
  eventCategoryPolitics: 'Governo e política',
  eventCategoryHousing: 'Casa e estilo de vida',
  eventCategoryFashion: 'Moda e beleza',
  eventCategoryMusic: 'Música',
  eventCategoryBusiness: 'Serviços profissionais e empresariais',
  eventCategorySocial: 'Organizações e causas beneficentes',
  eventCategoryOther: 'De outros',
  eventCategoryReligion: 'Religião e espiritualidade',
  eventCategoryHealth: 'Saúde e bem-estar',
  eventCategoryOutdoors: 'Viagens e atividades ao ar livre',
  /* End Places */

  urlOrLink: 'URL ou link',
  socialNetworkAdd: 'Adicionar rede social',
  eventCurrency: 'Moeda de evento',
  ticketTitle: 'Título de bilhete',
  ticketPrice: 'Preço do ingresso',
  ticketingServicePrice: 'Preço do serviço de bilhetagem',
  startOfSale: 'Início da Venda',
  endOfSale: 'Fim da Venda',
  ticketsNumber: 'Número de ingressos',
  maxTicketsPerPerson: 'Número máximo de ingressos por pessoa',
  deleteTicket: 'Excluir o bilhete',
  addTicket: 'Adicionar ticket',
  result: 'Resultado',
  ofPromoter: 'do promotor',
  upload: 'Carregar',
  allowedFormats: 'Apenas esses formatos são permitidos',
  maxPictureSize: 'Imagem deve ter um tamanho máximo de',
  and: 'E',
  dragAndDropFile: 'Arraste e solte o arquivo aqui',
  imageSuccessfullyLoaded: 'Imagem carregada com sucesso',
  deleteSelection: 'Excluir seleção',
  analyze: 'Analisar',
  atLeastOneFileToContinue: 'Digite pelo menos um arquivo para continuar',
  nextStep: 'Próximo passo',
  theFile: 'O arquivo',
  notAccepted: 'não foi aceito',
  seeEvent: 'Ver evento',
  registerAttender: 'Assistente de registro',
  advancedSearch: 'Pesquisa avançada',
  assistantsPerPage: 'Assistentes por página',
  assistantName: 'Nome do assistente',
  creation: 'Criação',
  ticket: 'Bilhete',
  register: 'Registro',
  assistantRegistered: 'Assistente registrado',
  buyer: 'Comprador',
  cost: 'Custo',
  parallelAnswer: 'Resposta Paralela',
  franchise: 'Franquia',
  bank: 'Banco',
  ofPurchase: 'de compra',
  download: 'Download',
  dataCopied: 'Dados copiados',
  errorTryAgain: 'Um erro ocorreu tente novamente',
  checkInState: 'Check-in',
  check: 'Verificar',
  checkedIn: 'Check-in',
  unCheck: 'Desmarque',
  zipCode: 'Código postal',
  currency: 'Moeda'
}
